/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import {useState} from 'react'
import {KTSVG} from '../../../helpers'
import { getExistNotificationsAll, getNotificationsAll, putMyNotifications, putNotificationsAll } from '../../../../app/services/notificationsService'
import { tempoPassado } from '../../../../app/utils/date'
import { renderBoldTags } from '../../../../app/utils/renderBoldTags'
import { useNavigate } from 'react-router-dom'
import { LoadingSpan } from '../../../../app/pages/components/Loadings/loadingSpan'
import { ModalPlant } from '../../../../app/pages/components/modalPlant'
import { useQuery } from 'react-query'
import useSize from '../../../../app/hooks/useSize'
import { useAuth } from '../../../../app/modules/auth'

type Props = {
  setSearchNotification: any
}

type ExistNotification = {
  myNotifications: boolean,
  mySearchNotificationsAlarmes: boolean,
  mySearchNotificationsReports: boolean,
  mySearchNotificationsSistema: boolean,
  mySearchNotificationsFaturas: boolean,
  mySearchNotificationsSolicitations: boolean
}

const HeaderNotificationsMenu = ({setSearchNotification} : Props) => {
  const [filterNotifications, setFilterNotifications] = useState<string>("ALARME");
  const [loadingPutNotifications, setLoadingPutNotifications] = useState(false);

  
  const [showCreateAppModal, setShowCreateAppModal] = useState<boolean>(false)
  const [myPlant, setMyPlant] = useState<string>("")

  const navigate = useNavigate();
  const {width} = useSize();
  const {currentUser} = useAuth();

  const { data: notifications = [], isLoading: loadingNotifications, refetch: refreshNotifications } = useQuery<any[]>(
    ["getNotificationsFilter", filterNotifications],
    async () => {
        if(currentUser && currentUser.role && currentUser.role.slug !== "ADMIN"){
          const myNotifications = await getNotificationsAll(filterNotifications)
          return myNotifications
        }else{
          return []
        }

    },
    {
      enabled: true,
      refetchInterval: 60000,
      onSuccess: (data) => {},
      onError: (error) => {
        console.log(error);
      },
    }
  );

  const { 
    data: myExistNotification = {
        myNotifications: false,
        mySearchNotificationsAlarmes: false,
        mySearchNotificationsReports: false,
        mySearchNotificationsSistema: false,
        mySearchNotificationsFaturas: false,
        mySearchNotificationsSolicitations: false
    }, 
    //isLoading: loadingExistNotifications, 
    refetch: refreshExistNotifications 
} = useQuery<ExistNotification>(

    ["getExistNotifications"],
    async () => {
        if(currentUser && currentUser.role && currentUser.role.slug !== "ADMIN"){
          const myExistNotificationsResponse = await getExistNotificationsAll()

          if(myExistNotificationsResponse && myExistNotificationsResponse.myNotifications){
            setSearchNotification(true)
          }else{
            setSearchNotification(false)
          }
        }
        return {
          myNotifications: false,
          mySearchNotificationsAlarmes: false,
          mySearchNotificationsReports: false,
          mySearchNotificationsSistema: false,
          mySearchNotificationsFaturas: false,
          mySearchNotificationsSolicitations: false
        }
    },
    {
      enabled: true,
      refetchInterval: 60000,
      onSuccess: (data) => {},
      onError: (error) => {
        console.log(error);
      },
    }
  );

  const putNotifications = async (id: string) => {
    try {
      setLoadingPutNotifications(true)
      const myBody = {
        confirm_read: true
      }
      await putMyNotifications(id, myBody)
      // setNotifications(myNotifications)
    } catch (error) {
      console.log(error)
    }finally{
      setLoadingPutNotifications(false)
      refreshNotifications()
      refreshExistNotifications()
    }
  }

  const putMyNotificationsAll = async () => {
    try {
      setLoadingPutNotifications(true)
      const myBody = {
        confirm_read: true,
        idsNotifications: notifications.map((notification) => notification.id)
      }
      await putNotificationsAll(myBody)
      // setNotifications(myNotifications)
    } catch (error) {
      console.log(error)
    }finally{
      setLoadingPutNotifications(false)
      refreshNotifications()
      refreshExistNotifications()
    }
  }

  const handleClickRead = (id: string) => {
    putNotifications(id)
  }

  const handleClickUpdateAll = () => {
    putMyNotificationsAll()
  }

  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column w-550px w-lg-550px'
      data-kt-menu='true'
    >
      <div
        className='d-flex flex-column bgi-no-repeat rounded-top bg-secondary'
        //style={{backgroundImage: `url('${toAbsoluteUrl('/media/misc/menu-header-bg.jpg')}')`}}
      >
        <h3 className='text-white fw-bold px-9 mt-10 mb-6'>
          Notificações <span className='fs-8 opacity-75 ps-2'>({notifications.length})</span>
        </h3>
  
        <ul className='nav nav-line-tabs nav-line-tabs-2x nav-stretch fw-bold px-9'>
          <li className='nav-item'>
            <a
              className='nav-link text-white opacity-75 opacity-state-100 pb-4 active'
              data-bs-toggle='tab'
              href='#kt_topbar_notifications_1'
              onClick={() => {setFilterNotifications('ALARME')}}
            >
              Alarmes
              {myExistNotification.mySearchNotificationsAlarmes &&
              (<span style={{marginLeft: '0.5rem'}} className='bullet bullet-dot bg-primary h-6px w-6px translate-middle animation-blink' />)}
            </a>
          </li>
  
          <li className='nav-item'>
            <a
              className='nav-link text-white opacity-75 opacity-state-100 pb-4'
              data-bs-toggle='tab'
              href='#kt_topbar_notifications_2'
              onClick={() => {setFilterNotifications('RELATORIOS')}}
            >
              Relatórios
              {myExistNotification.mySearchNotificationsReports === true &&
              (<span style={{marginLeft: '0.5rem'}} className='bullet bullet-dot bg-primary h-6px w-6px translate-middle animation-blink' />)}
            </a>
          </li>

          <li className='nav-item'>
            <a
              className='nav-link text-white opacity-75 opacity-state-100 pb-4'
              data-bs-toggle='tab'
              href='#kt_topbar_notifications_4'
              onClick={() => {setFilterNotifications('SOLICITACAO')}}
            >
              Solicitações
              {myExistNotification.mySearchNotificationsSolicitations === true &&
              (<span style={{marginLeft: '0.5rem'}} className='bullet bullet-dot bg-primary h-6px w-6px translate-middle animation-blink' />)}
            </a>
          </li>

          <li className='nav-item'>
            <a
              className='nav-link text-white opacity-75 opacity-state-100 pb-4'
              data-bs-toggle='tab'
              href='#kt_topbar_notifications_5'
              onClick={() => {setFilterNotifications('FATURAS')}}
            >
              Faturas
              {myExistNotification.mySearchNotificationsFaturas === true &&
              (<span style={{marginLeft: '0.5rem'}} className='bullet bullet-dot bg-primary h-6px w-6px translate-middle animation-blink' />)}
            </a>
          </li>
  
          <li className='nav-item'>
            <a
              className='nav-link text-white opacity-75 opacity-state-100 pb-4'
              data-bs-toggle='tab'
              href='#kt_topbar_notifications_3'
              onClick={() => {setFilterNotifications('SISTEMA')}}
            >
              Sistema
              {myExistNotification.mySearchNotificationsSistema &&
              (<span style={{marginLeft: '0.5rem'}} className='bullet bullet-dot bg-primary h-6px w-6px translate-middle animation-blink' />)}
            </a>
          </li>
        </ul>
      </div>
  
      <div className='tab-content'>
        
        <div className='tab-pane fade show active' id='kt_topbar_notifications_1' role='tabpanel'>
          {!loadingNotifications ? 
          <div className='scroll-y mh-325px my-5 px-8'>
            {notifications.length ? notifications.map((alert, index) => {
              if(alert.type === "ALARME"){
                return (
                  <div key={`alert${index}`} className={`d-flex flex-stack py-4 ${alert.confirm_read === true ? "bg-light" : ""}  mb-1 mt-1`}>
                    <div className='d-flex align-items-center'>
                      <div className='symbol symbol-35px me-4'>
                        <span className={clsx('symbol-label', `bg-light-warning`)}>
                          {' '}
                          <KTSVG
                            path={`/media/icons/duotune/general/gen044.svg`}
                            className={`svg-icon-2 svg-icon-warning`}
                          />
                        </span>
                      </div>
                      
      
                      <div className='mb-0 me-2'>
                        <a href='#' className='fs-6 text-gray-800 text-hover-primary fw-bolder'>
                          {alert.title}
                        </a>
                        <div className='text-gray-400 fs-7'>{renderBoldTags(alert.description)}</div>
                      </div>
  
                    </div>
    
                    <span className='badge badge-light fs-8'>{alert && alert.created_at ? tempoPassado(alert.created_at) : ""}</span>
  
                    <div>
                      <button
                        onClick={(event: any) => {
                          handleClickRead(alert.id)
                          if(alert.id_ref){
                            setMyPlant(alert.id_ref);
                            setShowCreateAppModal(true)
                          }
                        }}
                        disabled={loadingPutNotifications === true || alert.confirm_read === true ? true : false}
                        className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                        style={{marginLeft: '1.5rem'}}
                      >
                        <i className={`bi bi-eye-fill`} style={{fontSize: '1.2rem'}}></i>
                      </button>
                    </div>
                  </div>
                )
              }
            })
            :
            <div className='card py-3 px-4 d-flex flex-wrap' style={{height: '10rem', overflow: 'auto'}}>
                <div className='bg-light' 
                    style={{
                        width: '100%', 
                        height: '100%', 
                        display: 'flex', 
                        alignItems: 'center', 
                        justifyContent: 'center',
                        gap: '0.5rem',
                        flexDirection: 'column'
                    }}
                >
                    <KTSVG
                        path="/media/icons/duotune/general/gen004.svg"
                        className='svg-icon-3x me-1'
                    />
                    <h3 className='card-title d-flex align-items-center justify-content-center flex-column'>
                        <span className='text-muted fw-semibold fs-7'>Sem notificações!</span>
                    </h3>
                </div>
            </div>
          }
          </div> 
          : <div 
              style={{height: '10rem', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                <LoadingSpan style={{marginLeft: '0.5rem'}}/>
            </div>}
  
          <div className='py-3 text-center border-top'>
            <a href="#" className='btn btn-color-gray-600 btn-active-color-primary' onClick={() => {handleClickUpdateAll()}}>
              Marcar tudo como lido <KTSVG path='/media/icons/duotune/arrows/arr064.svg' className='svg-icon-5' />
            </a>
          </div>
        </div>

        <div className='tab-pane fade' id='kt_topbar_notifications_2' role='tabpanel'>
        {!loadingNotifications ? 
          <div className='scroll-y mh-325px my-5 px-8'>
            {notifications.length > 0 ? notifications.map((alert, index) => {
              if(alert.type === "RELATORIOS"){
                return (
                  <div key={`alert${index}`} className={`d-flex flex-stack py-4 ${alert.confirm_read === true ? "bg-light" : ""}  mb-1 mt-1`}>
                    <div className='d-flex align-items-center'>
                      <div className='symbol symbol-35px me-4'>
                        <span className={clsx('symbol-label', `bg-light`)}>
                          {' '}
                          <KTSVG
                            path={`/media/icons/duotune/files/fil005.svg`}
                            className={`svg-icon-2 svg-icon-dark`}
                          />
                        </span>
                      </div>
                      
      
                      <div className='mb-0 me-2'>
                        <a href='#' className='fs-6 text-gray-800 text-hover-primary fw-bolder'>
                          {alert.title}
                        </a>
                        <div className='text-gray-400 fs-7'>{renderBoldTags(alert.description)}</div>
                      </div>
  
                    </div>
    
                    <span className='badge badge-light fs-8'>{alert && alert.created_at ? tempoPassado(alert.created_at) : ""}</span>
  
                    <div>
                      <button
                        onClick={(event: any) => {
                          handleClickRead(alert.id)
                          navigate('/relatorios');
                        }}
                        disabled={loadingPutNotifications === true || alert.confirm_read === true ? true : false}
                        className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                        style={{marginLeft: '1.5rem'}}
                      >
                        <i className={`bi bi-eye-fill`} style={{fontSize: '1.2rem'}}></i>
                      </button>
                    </div>
                  </div>
                )
              }
            })
            :
            <div className='card py-3 px-4 d-flex flex-wrap' style={{height: '10rem', overflow: 'auto'}}>
                <div className='bg-light' 
                    style={{
                        width: '100%', 
                        height: '100%', 
                        display: 'flex', 
                        alignItems: 'center', 
                        justifyContent: 'center',
                        gap: '0.5rem',
                        flexDirection: 'column'
                    }}
                >
                    <KTSVG
                        path="/media/icons/duotune/general/gen004.svg"
                        className='svg-icon-3x me-1'
                    />
                    <h3 className='card-title d-flex align-items-center justify-content-center flex-column'>
                        <span className='text-muted fw-semibold fs-7'>Sem notificações!</span>
                    </h3>
                </div>
            </div>
          }
          </div> 
          : <div 
              style={{height: '10rem', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                <LoadingSpan style={{marginLeft: '0.5rem'}}/>
            </div>}
  
          <div className='py-3 text-center border-top'>
            <a href="#" className='btn btn-color-gray-600 btn-active-color-primary' onClick={() => {handleClickUpdateAll()}}>
              Marcar tudo como lido <KTSVG path='/media/icons/duotune/arrows/arr064.svg' className='svg-icon-5' />
            </a>
          </div>
        </div>

        <div className='tab-pane fade' id='kt_topbar_notifications_4' role='tabpanel'>
        {!loadingNotifications ? 
          <div className='scroll-y mh-325px my-5 px-8'>
            {notifications.length > 0 ? notifications.map((alert, index) => {
              if(alert.type === "SOLICITACAO"){
                return (
                  <div key={`alert${index}`} className={`d-flex flex-stack py-4 ${alert.confirm_read === true ? "bg-light" : ""}  mb-1 mt-1`}>
                    <div className='d-flex align-items-center'>
                      <div className='symbol symbol-35px me-4'>
                        <span className={clsx('symbol-label', `bg-light`)}>
                          {' '}
                          <KTSVG
                            path={`/media/icons/duotune/communication/com007.svg`}
                            className={`svg-icon-2 svg-icon-dark`}
                          />
                        </span>
                      </div>
                      
      
                      <div className='mb-0 me-2'>
                        <a href='#' className='fs-6 text-gray-800 text-hover-primary fw-bolder'>
                          {alert.title}
                        </a>
                        <div className='text-gray-400 fs-7'>{renderBoldTags(alert.description)}</div>
                      </div>
  
                    </div>
    
                    <span className='badge badge-light fs-8'>{alert && alert.created_at ? tempoPassado(alert.created_at) : ""}</span>
  
                    <div>
                      <button
                        onClick={(event: any) => {
                          handleClickRead(alert.id)
                          navigate(width < 1200 ? '/solicitacoes' : '/storeServices/1');
                        }}
                        disabled={loadingPutNotifications === true || alert.confirm_read === true ? true : false}
                        className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                        style={{marginLeft: '1.5rem'}}
                      >
                        <i className={`bi bi-eye-fill`} style={{fontSize: '1.2rem'}}></i>
                      </button>
                    </div>
                  </div>
                )
              }
            })
            :
            <div className='card py-3 px-4 d-flex flex-wrap' style={{height: '10rem', overflow: 'auto'}}>
                <div className='bg-light' 
                    style={{
                        width: '100%', 
                        height: '100%', 
                        display: 'flex', 
                        alignItems: 'center', 
                        justifyContent: 'center',
                        gap: '0.5rem',
                        flexDirection: 'column'
                    }}
                >
                    <KTSVG
                        path="/media/icons/duotune/general/gen004.svg"
                        className='svg-icon-3x me-1'
                    />
                    <h3 className='card-title d-flex align-items-center justify-content-center flex-column'>
                        <span className='text-muted fw-semibold fs-7'>Sem notificações!</span>
                    </h3>
                </div>
            </div>
          }
          </div> 
          : <div 
              style={{height: '10rem', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                <LoadingSpan style={{marginLeft: '0.5rem'}}/>
            </div>}
  
          <div className='py-3 text-center border-top'>
            <a href="#" className='btn btn-color-gray-600 btn-active-color-primary' onClick={() => {handleClickUpdateAll()}}>
              Marcar tudo como lido <KTSVG path='/media/icons/duotune/arrows/arr064.svg' className='svg-icon-5' />
            </a>
          </div>
        </div>

        <div className='tab-pane fade' id='kt_topbar_notifications_5' role='tabpanel'>
        {!loadingNotifications ? 
          <div className='scroll-y mh-325px my-5 px-8'>
            {notifications.length > 0 ? notifications.map((alert, index) => {
              if(alert.type === "FATURAS"){
                return (
                  <div key={`alert${index}`} className={`d-flex flex-stack py-4 ${alert.confirm_read === true ? "bg-light" : ""}  mb-1 mt-1`}>
                    <div className='d-flex align-items-center'>
                      <div className='symbol symbol-35px me-4'>
                        <span className={clsx('symbol-label', `bg-light`)}>
                          {' '}
                          <KTSVG
                            path={`/media/icons/duotune/ecommerce/ecm010.svg`}
                            className={`svg-icon-2 svg-icon-dark`}
                          />
                        </span>
                      </div>
                      
      
                      <div className='mb-0 me-2'>
                        <a href='#' className='fs-6 text-gray-800 text-hover-primary fw-bolder'>
                          {alert.title}
                        </a>
                        <div className='text-gray-400 fs-7'>{renderBoldTags(alert.description)}</div>
                      </div>
  
                    </div>
    
                    <span className='badge badge-light fs-8'>{alert && alert.created_at ? tempoPassado(alert.created_at) : ""}</span>
  
                    <div>
                      <button
                        onClick={(event: any) => {
                          handleClickRead(alert.id)
                          navigate('/faturas/');
                        }}
                        disabled={loadingPutNotifications === true || alert.confirm_read === true ? true : false}
                        className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                        style={{marginLeft: '1.5rem'}}
                      >
                        <i className={`bi bi-eye-fill`} style={{fontSize: '1.2rem'}}></i>
                      </button>
                    </div>
                  </div>
                )
              }
            })
            :
              <div className='card py-3 px-4 d-flex flex-wrap' style={{height: '10rem', overflow: 'auto'}}>
                  <div className='bg-light' 
                      style={{
                          width: '100%', 
                          height: '100%', 
                          display: 'flex', 
                          alignItems: 'center', 
                          justifyContent: 'center',
                          gap: '0.5rem',
                          flexDirection: 'column'
                      }}
                  >
                      <KTSVG
                          path="/media/icons/duotune/general/gen004.svg"
                          className='svg-icon-3x me-1'
                      />
                      <h3 className='card-title d-flex align-items-center justify-content-center flex-column'>
                          <span className='text-muted fw-semibold fs-7'>Sem notificações!</span>
                      </h3>
                  </div>
              </div>
            }
          </div> 
          : <div 
              style={{height: '10rem', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                <LoadingSpan style={{marginLeft: '0.5rem'}}/>
            </div>}
  
          <div className='py-3 text-center border-top'>
            <a href="#" className='btn btn-color-gray-600 btn-active-color-primary' onClick={() => {handleClickUpdateAll()}}>
              Marcar tudo como lido <KTSVG path='/media/icons/duotune/arrows/arr064.svg' className='svg-icon-5' />
            </a>
          </div>
        </div>

        <div className='tab-pane fade' id='kt_topbar_notifications_3' role='tabpanel'>
          {!loadingNotifications ? <div className='scroll-y mh-325px my-5 px-8'>
            {notifications.length > 0 ? notifications.map((alert, index) => {
              if(alert.type === "SISTEMA"){
                return (
                  <div key={`alert${index}`} className={`d-flex flex-stack py-4 ${alert.confirm_read === true ? "bg-light" : ""}  mb-1 mt-1`}>
                    <div className='d-flex align-items-center'>
                      <div className='symbol symbol-35px me-4'>
                        <span className={clsx('symbol-label', `bg-light`)}>
                          {' '}
                          <KTSVG
                            path={`/media/icons/duotune/coding/cod001.svg`}
                            className={`svg-icon-2 svg-icon-dark`}
                          />
                        </span>
                      </div>
                      
      
                      <div className='mb-0 me-2'>
                        <a href='#' className='fs-6 text-gray-800 text-hover-primary fw-bolder'>
                          {alert.title}
                        </a>
                        <div className='text-gray-400 fs-7'>{renderBoldTags(alert.description)}</div>
                      </div>
  
                    </div>
    
                    <span className='badge badge-light fs-8'>{alert && alert.created_at ? tempoPassado(alert.created_at) : ""}</span>
  
                    <div>
                      <button
                        onClick={(event: any) => {
                          handleClickRead(alert.id)
                        }}
                        disabled={loadingPutNotifications === true || alert.confirm_read === true ? true : false}
                        className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                        style={{marginLeft: '1.5rem'}}
                      >
                        <i className={`bi bi-eye-fill`} style={{fontSize: '1.2rem'}}></i>
                      </button>
                    </div>
                  </div>
                )
              }
            })
            :
            <div className='card py-3 px-4 d-flex flex-wrap' style={{height: '10rem', overflow: 'auto'}}>
                <div className='bg-light' 
                    style={{
                        width: '100%', 
                        height: '100%', 
                        display: 'flex', 
                        alignItems: 'center', 
                        justifyContent: 'center',
                        gap: '0.5rem',
                        flexDirection: 'column'
                    }}
                >
                    <KTSVG
                        path="/media/icons/duotune/general/gen004.svg"
                        className='svg-icon-3x me-1'
                    />
                    <h3 className='card-title d-flex align-items-center justify-content-center flex-column'>
                        <span className='text-muted fw-semibold fs-7'>Sem notificações!</span>
                    </h3>
                </div>
            </div>
          }
          </div> : 
            <div 
              style={{height: '10rem', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                <LoadingSpan style={{marginLeft: '0.5rem'}}/>
            </div>}
  
          <div className='py-3 text-center border-top'>
            <a href="#" className='btn btn-color-gray-600 btn-active-color-primary' onClick={() => {handleClickUpdateAll()}}>
              Marcar tudo como lido <KTSVG path='/media/icons/duotune/arrows/arr064.svg' className='svg-icon-5' />
            </a>
            {/* <Link
              to='/crafted/pages/profile'
              className='btn btn-color-gray-600 btn-active-color-primary'
            >
              
            </Link> */}
          </div>
        </div>
  
        {/* <div className='tab-pane fade show active' id='kt_topbar_notifications_2' role='tabpanel'>
          <div className='d-flex flex-column px-9'>
            <div className='pt-10 pb-0'>
              <h3 className='text-dark text-center fw-bolder'>Get Pro Access</h3>
  
              <div className='text-center text-gray-600 fw-bold pt-1'>
                Outlines keep you honest. They stoping you from amazing poorly about drive
              </div>
  
              <div className='text-center mt-5 mb-9'>
                <a
                  href='#'
                  className='btn btn-sm btn-primary px-6'
                  data-bs-toggle='modal'
                  data-bs-target='#kt_modal_upgrade_plan'
                >
                  Upgrade
                </a>
              </div>
            </div>
  
            <div className='text-center px-4'>
              <img
                className='mw-100 mh-200px'
                alt='metronic'
                src={toAbsoluteUrl('/media/illustrations/sketchy-1/1.png')}
              />
            </div>
          </div>
        </div> */}
  

      </div>
      <ModalPlant 
          show={showCreateAppModal} 
          handleClose={() => {
            setMyPlant("")
            setShowCreateAppModal(false)
          }} 
          plant={myPlant}
        />
    </div>
  )
}

export {HeaderNotificationsMenu}
